import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxGridHeaderCellComponent } from './checkbox-grid-header-cell/checkbox-grid-header-cell.component';
import { CheckboxGridHeaderComponent } from './checkbox-grid-header.component';

@NgModule({
  declarations: [CheckboxGridHeaderComponent, CheckboxGridHeaderCellComponent],
  exports: [CheckboxGridHeaderComponent, CheckboxGridHeaderCellComponent],
  imports: [CommonModule],
})
export class CheckboxGridHeaderModule {}
